import React from "react";
import { InputRangeRow } from "./index";
// Used by the Heli (pirn) KV2002 machine

export default function GirthRow() {
   return (
      <InputRangeRow
         titleProp={"Girth"}
         descriptionProp={""}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={999999} //some default value
         propertyNameProp={"girth"}
         errorDialogueProp={"Cannot be left empty"}
         floatProp={false}
         readOnlyProp={true}
      />
   );
}
